<template>
  <div class="body">
      <Headtow></Headtow>
      <Headfor></Headfor>
      <div id="w-center1400">
        <div class="clear"></div>
        <div class="h-10"></div>

        <div id="products_type">
          <el-radio-group v-model="checkinfo" @change="type" size="medium">
              <el-radio-button label="-1" >全部</el-radio-button>
              <el-radio-button label="0" >待审核</el-radio-button>
              <el-radio-button label="1" >待发货</el-radio-button>
              <el-radio-button label="2" >已发货</el-radio-button>
              <el-radio-button label="3" >已完成</el-radio-button>
              <el-radio-button label="4" >驳回</el-radio-button>

            </el-radio-group>
            <div class="h-10"></div>
        </div>


        <el-table
            border
            class="table"
            ref="multipleTable"
            :data="list"
            tooltip-effect="dark"
            style="width: 100%"
            v-loading="loading"
          >

          <el-table-column
            prop="ordernumber"
            label="订单号"
            min-width="13%"
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column prop="name" label="姓名" min-width="6%">
            <template slot-scope="scope">
             {{ scope.row.name}}
            </template>
          </el-table-column>
          <el-table-column label="联系方式" min-width="10%" prop="tel">
            <template slot-scope="scope">
              {{ scope.row.tel}}
            </template>
          </el-table-column>
          <el-table-column label="学校" min-width="16%" prop="dizhi">
            <template slot-scope="scope">
            {{ scope.row.dizhi}}
            </template>
          </el-table-column>
          <el-table-column label="下单时间" min-width="14%" sortable prop="create_time">
            <template slot-scope="scope">
            {{ scope.row.create_time}}
            </template>
          </el-table-column>
          <el-table-column label="订单状态" min-width="11%">
            <template slot-scope="scope">

              <div class="tip-tag">
                  <el-tag type="info" v-if="scope.row.checkinfo === 0">{{ scope.row.checkinfo_text}}</el-tag>
                  <el-tag v-if="scope.row.checkinfo === 1">{{ scope.row.checkinfo_text}}</el-tag>
                  <el-tag type="primary" v-if="scope.row.checkinfo === 2">{{ scope.row.checkinfo_text}}</el-tag>
                  <el-tag type="danger" v-if="scope.row.checkinfo == 3">{{ scope.row.checkinfo_text}}</el-tag>
                  <el-tag type="warning" v-if="scope.row.checkinfo == 4">{{ scope.row.checkinfo_text}}</el-tag>

                </div>
            </template>
          </el-table-column>

          <el-table-column prop="orderamount" sortable label="总价" min-width="8%">
            <template slot-scope="scope">
              {{ scope.row.orderamount}}
            </template>
          </el-table-column>

          <el-table-column label="操作" min-width="15%">
            <template slot-scope="scope">
               <el-button  v-if="user.sf === 1 && scope.row.checkinfo === 0"   type="success" size="mini"   @click="ok(scope.row.id,1)"   >通过</el-button >
                <el-button  v-if="user.sf === 1 && scope.row.checkinfo === 0" size="mini" type="warning" @click="bh(scope.row.id,4)"  >驳回</el-button>
                <el-button  v-if="scope.row.checkinfo === 2" size="mini" type="success" @click="ok(scope.row.id,3)"  >确认收货</el-button>
                <el-button    type="danger"     size="mini"  class="deleteBtn"  @click="tc(scope.row.ordernumber)" >查看</el-button>

            </template>
          </el-table-column>
          </el-table>
          <div class="page">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="12"
              @current-change="handleCurrentChange"
              :total="total">
            </el-pagination>
          </div>


          <el-dialog title="订单信息" :visible.sync="dialogTableVisible" width="80%" @close='gb'>
            <div style=" overflow: auto;height: 500px;">
              <div style="width: 100%;display: block;box-sizing: border-box;">
                <el-row >
                  <el-divider class="fize-da">收货人信息</el-divider>
                  <el-col :span="6"><div class="public-yy">选购员：{{info.name}}</div></el-col>
                  <el-col :span="6"><div class="public-yy">电话：{{info.tel}}</div></el-col>
                  <el-col :span="6"><div class="public-yy">采购人：{{info.xzname}}</div></el-col>
                  <el-col :span="6"><div class="public-yy">单位全称：{{info.dizhi}}</div></el-col>
                </el-row>
                <div class="h-10"></div>
                <el-divider class="fize-da">订单信息</el-divider>
                <el-row >
                  <el-col :span="6"><div class="public-yy">订单编号：{{info.ordernumber}}</div></el-col>
                  <el-col :span="6"><div class="public-yy">创建时间：{{info.create_time}}</div></el-col>
                  <!-- <el-col :span="4"><div class="public-yy">付款时间：{{info.pay_time}}</div></el-col> -->
                  <el-col :span="6"><div class="public-yy">发货时间：{{info.delivery_time}}</div></el-col>
                  <el-col :span="6"><div class="public-yy">订单状态：{{info.checkinfo_text}}</div></el-col>
                </el-row>
                <div class="h-10"></div>
                <el-divider class="fize-da">发货信息</el-divider>
                <el-row >
                  <el-col :span="6"><div class="public-yy">快递公司：{{info.express}}</div></el-col>
                  <el-col :span="6"><div class="public-yy">快递单号：{{info.express_number}}</div></el-col>
                </el-row>


                <div v-if="info.checkinfo == 4">
                  <div class="h-10"></div>
                  <el-row >
                    <el-col :span="20"><div class="public-yy">驳回原因：{{info.message}}</div></el-col>
                  </el-row>
                </div>

              </div>

              <el-divider class="fize-da">图书信息</el-divider>

              <el-table
                v-loading="loading"
                show-summary
                class="table"
                ref="multipleTable"
                :data="tableData.filter(data => !search || data.gtitle.toLowerCase().includes(search.toLowerCase()))"
                tooltip-effect="dark"
                style="width: 100%"
                :summary-method="getSummaries"
              >
                  <!-- <el-table-column type="selection" min-width="10.5%"> </el-table-column> -->
                 <!-- <el-table-column label="商品预览" min-width="10.5%">
                    <template slot-scope="scope">{{ scope.row.create_time }}</template>
                  </el-table-column> -->
                  <el-table-column
                    prop="tm"
                    label="书号"
                    min-width="11%"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="gtitle"
                    label="书名"
                    min-width="25%"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column prop="price" label="出版社" min-width="12%">
                    <template slot-scope="scope">
                      {{ scope.row.cbs}}
                    </template>
                  </el-table-column>

                  <el-table-column prop="price" label="作者" show-overflow-tooltip min-width="12%">
                    <template slot-scope="scope">
                      {{ scope.row.zz}}
                    </template>
                  </el-table-column>

                  <el-table-column prop="price" label="中图分类" show-overflow-tooltip min-width="8%">
                    <template slot-scope="scope">
                      {{ scope.row.ztfl}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="price" label="定价" min-width="8%">
                    <template slot-scope="scope">
                      {{ scope.row.price}}
                    </template>
                  </el-table-column>
                  <el-table-column prop="num" label="数量" min-width="12%">
                    <template slot-scope="scope">
                      <el-input-number
                      @change="handleChange(scope.row.num,scope.row.id)"
                        size="mini"
                        v-model="scope.row.num"
                        :min="1"
                        :disabled="user.sf==1 && info.checkinfo == 0 || info.checkinfo == 4 ? false :  true"
                      ></el-input-number>
                    </template>
                  </el-table-column>
                  <el-table-column label="总价" min-width="11%">
                    <template slot-scope="scope">
                      {{ (scope.row.price * scope.row.num).toFixed(2) }}
                    </template>
                  </el-table-column>
                  <el-table-column  min-width="15%"    >

                    <template slot="header" slot-scope="scope">
                        <el-input
                          v-model="search"
                          size="mini"
                          placeholder="输入关键字搜索[书名]"/>
                      </template>

                    <template slot-scope="scope">
                      <el-button
                        v-if="user.sf==1 && info.checkinfo == 0 || info.checkinfo == 4"
                        type="text"
                        size="small"
                        class="deleteBtn"
                        icon="el-icon-delete"
                        @click="deletesc(scope.row.id)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <div class="h-30"></div>
                <el-button  type="warning" v-if="info.checkinfo === 4" style="float: right;margin-right: 20px;"  @click="ok(info.id,0)" >提交</el-button>
                <el-button  type="success" v-if="info.checkinfo === 4" style="float: right;margin-right: 20px;"  >
                  <router-link  :to="{path:'/Index',query: {index:1}}" style="color: #fff;">添加书籍</router-link>
                </el-button>
                <el-button type="danger"  @click="xz()">下载</el-button>
          </div>
         </el-dialog>


         <!-- 驳回 -->
         <el-dialog title="驳回原因" :visible.sync="dialogFormVisible">
           <el-form :model="form">
             <el-form-item  :label-width="formLabelWidth">
                <el-input type="textarea" v-model="form.message" placeholder="请输入驳回原因"></el-input>
             </el-form-item>

           </el-form>
           <div slot="footer" class="dialog-footer">
             <el-button @click="qx">取 消</el-button>
             <el-button type="primary" @click="onSubmit">确 定</el-button>
           </div>
         </el-dialog>






      </div>
       <Foot></Foot>
  </div>

</template>

<script>
import headtow from '@/components/public/headtow.vue';
import headfor from '@/components/public/headfor.vue';
import foot from '@/components/public/foot.vue'

export default{
  data(){
    return {
       search: '',
      dialogFormVisible: false,
      dialogTableVisible: false,
      tableData:[],
      selNum:0,
      ordernumber:'',

      loading:true,
      list:[],
      page:1,
      total:0,
      info:[],

      checkinfo:-1,

      form:{
        message:'',
      },
      formLabelWidth:"0px",
      bhordernumber:0,

      options: [],
      value: [],

    }
  },
  components: {
    'Headtow': headtow,  //将别名demo 变成 组件 Demo
    'Headfor': headfor,
    'Foot': foot,
  },
  mounted(){
    this.recordapi();
  },

  methods:{
     // 订单详情
     xz(){
      window.location=process.env.API_HOST+'Order/download?ordernumber='+ this.ordernumber
     },
     // 关闭弹窗
     gb(){
        this.recordapi();
     },
     tc(e){
       this.dialogTableVisible = true
       this.ordernumber = e
       console.log(e);
       var that = this;
       var userid = that.$cookieStore.getCookie('userid');
       that.$api.post("/Order/cart",{'ordernumber':this.$encruption(e.toString()),'userid':userid}).then(res => {
          console.log(res);
          that.tableData= res.data.lists;
          that.info= res.data.info;
          that.options= res.data.options;
          that.loading = false
       });
     },


     // 取消驳回
     qx(){
       this.form.message ='',
       this.dialogFormVisible = false
     },
     // 驳回
     bh(e,zt){
       this.dialogFormVisible = true
       this.bhordernumber = e
     },
     onSubmit(){
       var that = this;
      console.log();
      console.log();

       var that = this;
       var userid = that.$cookieStore.getCookie('userid');
       that.$api.post("/Order/bh",{'message':that.form.message,'zt':4,'checkinfo':that.checkinfo,'id':that.bhordernumber,'page':1,'userid':userid,}).then(res => {
        console.log(res);
         this.$message({
           message: res.msg,
           type: 'success'
         });
          this.form.message ='',
          this.dialogFormVisible = false
          this.recordapi();
      })

     },
    // 审核/确认收货
    ok(e,zt){
        console.log(e);
        if(zt == 0){
          this.dialogTableVisible = false;
        }
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Order/ok",{'zt':zt,'checkinfo':that.checkinfo,'id':e,'page':1,'userid':userid,}).then(res => {
         console.log(res);
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.recordapi();
       })
    },
    recordapi(){
      var that = this;
      var userid = that.$cookieStore.getCookie('userid');
      that.$api.post("/Order/index",{'checkinfo':that.checkinfo,'page':this.page,'userid':userid,}).then(res => {
        console.log(res);

        that.user= res.data.user;
        that.list= res.data.order_list.data;
        this.total = res.data.order_list.total

        this.loading = false
      });
    },
    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.page = val;
      this.recordapi();
    },

    // 分类
    type:function(e){
      this.loading = true,
      console.log(e);
      this.page = 1;
      this.keywords = '';
      this.checkinfo = e;

      this.recordapi();
    },




    getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        console.log(columns);
        if (columns.length > 0) {
          this.totalPrice = this.tableData
            .map((row) => row.num * row.price)
            .reduce((total, num) => total + num, 0)
            ;

          this.num = this.tableData
          .map((row) => row.num)
          .reduce((total, num) => total + num, 0)
        } else {
          this.totalPrice = 0;
        }
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "合计";
            return;
          }
          if (index ===1) {

          }
          if (index === 6) {
          sums[index] = "总数："+this.num ;
          return;
          }
          if (index === 7) {
            sums[index] = this.totalPrice.toFixed(2) + "元";
            return;
          }

        });
        return sums;
    },

    // 删除商品
    deletesc(id) {
        console.log(id);
        var that = this;
        var userid = that.$cookieStore.getCookie('userid');
        that.$api.post("/Shopcart/delete",{'userid':userid,'id':this.$encruption(id.toString())}).then(res => {
          console.log(res);

          if(res.code==1){
            this.$message({
              message: res.msg,
              type: 'success'
            });
             this.del(id);
             this.recordapi();
          }else{
            this.$message({
              message: res.msg,
              type: 'success'
            });
          }
        });
    },

    del(item){
      for (let i=0; i<this.tableData.length; i++){
        if (this.tableData[i]['id'] == item){
          this.tableData.splice(i, 1)
        }
      }
      console.log(this.tableData)
    },

    // 数量   数量/ 商品id
    handleChange(value,id) {
      var that = this;
      var userid = that.$cookieStore.getCookie('userid');
      that.$api.post("/Shopcart/num",{'userid':userid,'num':value,'id':this.$encruption(id.toString())}).then(res => {
        console.log(res);
      });

    },





  }

 }
</script>



// WEBPACK FOOTER //
// src/components/Orderlist.vue